export function selectScroll() {
    document.addEventListener("DOMContentLoaded", function () {
        const cards = document.querySelectorAll(".product-card-section__info-block__card");

        cards.forEach(card => {
            const scrollContainer = card.querySelector(".scrollX");
            const scrollLeftBtn = card.querySelector(".__select-slide-left");
            const scrollRightBtn = card.querySelector(".__select-slide-right");
            const scrollAmount = 150;

            if (!scrollContainer || !scrollLeftBtn || !scrollRightBtn) return;

            scrollLeftBtn.addEventListener("click", () => {
                scrollContainer.scrollBy({
                    left: -scrollAmount,
                    behavior: "smooth"
                });
            });

            scrollRightBtn.addEventListener("click", () => {
                console.log('123');
                scrollContainer.scrollBy({
                    left: scrollAmount,
                    behavior: "smooth"
                });
            });

            function updateArrowVisibility() {
                const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
                scrollLeftBtn.style.display = scrollContainer.scrollLeft > 0 ? "flex" : "none";
                scrollRightBtn.style.display = scrollContainer.scrollLeft < maxScrollLeft - 1 ? "flex" : "none";
            }

            scrollContainer.addEventListener("scroll", updateArrowVisibility);
            window.addEventListener("resize", updateArrowVisibility);
            updateArrowVisibility();
        });
    });

}
